module.exports = __webpack_public_path__ + "media/images/edion/en/edion-tax-free-banner-fe1481379242a9b54ff40f3682852800.png";